document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
        const target = document.querySelector(link.getAttribute('href'));

        if (!target) return;

        e.preventDefault();

        const headerOffset = 150
        const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
            top: elementPosition - headerOffset,
            behavior: 'smooth'
        });
    });
});
